import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Constants } from 'src/app/common/constants';
import { SeoService } from 'src/app/common/seo.service';
import * as AOS from 'aos';
@Component({
  selector: 'app-tech-hiring',
  templateUrl: './tech-hiring.component.html',
  styleUrl: './tech-hiring.component.css'
})
export class TechHiringComponent {
 baseUrl = Constants.baseUrl;
    isBrowser:boolean=false;
    constructor( private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private seoService:SeoService,
    private metaService: Meta) {this.isBrowser=isPlatformBrowser(this.platformId);}
    ngOnInit(): void {
      this.seoService.createLinkForCanonicalURL();
      this.setTitleAndMetaTags();
      let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/tech-hiring/"
    },
    "headline": "Recruiter Expertise in IT Hiring & Talent Acquisition | Maganti IT Resource",
    "description": "Leverage Maganti IT Resource's recruiter expertise to find top tech talent faster. Our experienced recruiters specialize in IT hiring, screening, and candidate alignment.",
    "image": "https://mitresource.com/assets/images/techstaffing-images/applicationmodernization.png",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2024-10-28"
  }
  `;
    this._renderer2.appendChild(this._document.body, script);
      if(this.isBrowser){     
        AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
        AOS.init({
          once: true, 
        });
      }
      this.setTitleAndMetaTags();
      this.seoService.createLinkForCanonicalURL();
    }
    private setTitleAndMetaTags(): void {
      this.titleService.setTitle('Recruiter Expertise in IT Hiring & Talent Acquisition | Maganti IT Resource');
      this.metaService.addTags([
        { name: 'description', content: "Leverage Maganti IT Resource's recruiter expertise to find top tech talent faster. Our experienced recruiters specialize in IT hiring, screening, and candidate alignment." },
        { property: 'og:type', content: 'website' },
        { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
        { property: 'og:title', content: 'Recruiter Expertise in IT Hiring & Talent Acquisition | Maganti IT Resource' },
        { property: 'og:url', content: 'https://mitresource.com/tech-hiring/' },
        { property: 'og:image', content: 'https://mitresource.com/assets/images/tech-hiring/image (1).png' },
        { property: 'og:description', content: 'Discover the power of recruiter expertise at Maganti IT Resource. Our tech-focused recruitment team ensures precise hiring and faster placements' },
      ]);
    }
}
